import { createContext } from 'react';
import { ICreateGameDeveloper } from 'types';

export type TTypeOfCreateGameDeveloperModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error';

export interface ICreateGameDeveloperState {
	name: string;
	dataForSubmit: ICreateGameDeveloper | null;
	typeOfModalWindow: TTypeOfCreateGameDeveloperModalWindow;
}

export const createGameDeveloperInitialState: ICreateGameDeveloperState = {
	name: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateGameDeveloperContext extends ICreateGameDeveloperState {
	changeName(value: string): void;
	setDataForSubmit(value: ICreateGameDeveloper | null): void;
	changeTypeOfModalWindow(value: TTypeOfCreateGameDeveloperModalWindow): void;
	resetFields(): void;
}

export const CreateGameDeveloperContext = createContext<ICreateGameDeveloperContext>({
	changeName: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createGameDeveloperInitialState,
});
